import { Injectable } from '@angular/core';

@Injectable()
export class PromotionPagingService {
  public page: any = {
    'pageNumber': 0,
    'size': 10,
    'sortProperty': '',
    'sortDirection': '',
    'filter':  {
        'status': 0,
        'searchValue': '',
    }
  };
};
